export enum PaymentProviders {
    ASK = 'ask',
    WORLDPAY = 'worldpay',
    SKRILL = 'skrill',
    PAYPAL = 'paypal',
    GLOBAL_POKER = 'globalPoker',
    PRIZEOUT = 'prizeout',
    FLYKK = 'flykk',
    ACH = 'ach',
    EML = 'eml',
    PAZE = 'paze',
}